export function VintageHeaderIcon() {
    return {
        __html: '' +
            '<?xml version="1.0" encoding="utf-8"?>' +
            '<!-- Generator: Adobe Illustrator 23.0.2, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->' +
            '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"' +
            ' viewBox="0 0 100 100" style="enable-background:new 0 0 100 100;" xml:space="preserve">' +
            '<style type="text/css">' +
            '.st0{fill:url(#SVGID_1_);}' +
            '.st1{fill:url(#SVGID_2_);}' +
            '.st2{fill:url(#SVGID_3_);}' +
            '.st3{fill:url(#SVGID_4_);}' +
            '.st4{fill:url(#SVGID_5_);}' +
            '.st5{fill:url(#SVGID_6_);}' +
            '</style>' +
            '<g>' +
            '<g>' +
            '<linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="63.1295" y1="48.752" x2="100" y2="48.752">' +
            '<stop  offset="0" style="stop-color:#c29f49"/>' +
            '<stop  offset="1" style="stop-color:#e5d390"/>' +
            '</linearGradient>' +
            '<path class="st0" d="M97.84,45.67c0.94-0.41,1.64-1.21,1.99-2.48c0.33-1.25,0.22-2.97-0.66-4.92c-0.87-1.93-2.66-4.03-5.23-5.51' +
            'c-2.56-1.5-5.84-2.25-9.05-2.01c-1.62,0.07-3.65,0.54-5.81,1.4c-2.15,0.86-4.38,2.2-6.37,3.93c-2,1.72-3.79,3.83-5.2,6.11' +
            'c-1.42,2.28-2.47,4.73-3.18,7.12c-0.68,2.41-1.03,4.74-1.16,6.86c-0.04,1.06-0.05,2.07-0.02,3c0.07,0.94,0.12,1.81,0.23,2.6' +
            'c0.13,0.79,0.25,1.5,0.38,2.12c0.14,0.62,0.32,1.15,0.46,1.58c0.31,0.86,0.59,1.33,0.82,1.33c0.21,0,0.49-0.47,0.83-1.28' +
            'c0.35-0.91,0.79-2.03,1.29-3.31c0.27-0.67,0.6-1.39,0.92-2.15c0.35-0.75,0.74-1.53,1.14-2.32c0.85-1.57,1.86-3.17,3-4.64' +
            'c1.17-1.46,2.48-2.78,3.84-3.84c1.36-1.07,2.76-1.89,4.06-2.45c1.3-0.57,2.5-0.87,3.47-1.01c0.24-0.06,0.47-0.06,0.69-0.09' +
            'c0.22-0.03,0.42-0.06,0.61-0.06c0.19-0.01,0.36-0.02,0.53-0.05c0.16,0.01,0.3,0,0.44-0.01c1.08-0.07,1.94-0.14,2.81-0.17' +
            'c0.86-0.04,1.81-0.06,2.84,0.07C93.6,45.71,95.93,46.5,97.84,45.67z"/>' +
            '</g>' +
            '<linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="36.1295" y1="36.2099" x2="65.6092" y2="36.2099">' +
            '<stop  offset="0" style="stop-color:#c29f49"/>' +
            '<stop  offset="1" style="stop-color:#e5d390"/>' +
            '</linearGradient>' +
            '<path class="st1" d="M65.61,28.44c-5.77,13.09-7.32,31.46-7.5,33.88c-0.01,0.15-0.1,0.27-0.21,0.27l-5.63,6.37' +
            'c-0.75,0.84-2.06,0.84-2.81,0l-5.63-6.37c-0.11,0-0.2-0.11-0.21-0.27c-0.18-2.42-1.49-19.38-7.5-33.88' +
            'c-0.05-0.11,11.6-20.92,14.22-25.27c0.26-0.44,0.78-0.44,1.04,0C54.01,7.51,65.66,28.32,65.61,28.44z"/>' +
            '<g>' +
            '<linearGradient id="SVGID_3_" gradientUnits="userSpaceOnUse" x1="0.9946" y1="48.752" x2="37.8652" y2="48.752">' +
            '<stop  offset="0" style="stop-color:#c29f49"/>' +
            '<stop  offset="1" style="stop-color:#e5d390"/>' +
            '</linearGradient>' +
            '<path class="st2" d="M3.16,45.67c-0.94-0.41-1.64-1.21-1.99-2.48c-0.33-1.25-0.22-2.97,0.66-4.92c0.87-1.93,2.66-4.03,5.23-5.51' +
            'c2.56-1.5,5.84-2.25,9.05-2.01c1.62,0.07,3.65,0.54,5.81,1.4c2.15,0.86,4.38,2.2,6.37,3.93c2,1.72,3.79,3.83,5.2,6.11' +
            'c1.42,2.28,2.47,4.73,3.18,7.12c0.68,2.41,1.03,4.74,1.16,6.86c0.04,1.06,0.05,2.07,0.02,3c-0.07,0.94-0.12,1.81-0.23,2.6' +
            'c-0.13,0.79-0.25,1.5-0.38,2.12c-0.14,0.62-0.32,1.15-0.46,1.58c-0.31,0.86-0.59,1.33-0.82,1.33c-0.21,0-0.49-0.47-0.83-1.28' +
            'c-0.35-0.91-0.79-2.03-1.29-3.31c-0.27-0.67-0.6-1.39-0.92-2.15c-0.35-0.75-0.74-1.53-1.14-2.32c-0.85-1.57-1.86-3.17-3-4.64' +
            'c-1.17-1.46-2.48-2.78-3.84-3.84c-1.36-1.07-2.76-1.89-4.06-2.45c-1.3-0.57-2.5-0.87-3.47-1.01c-0.24-0.06-0.47-0.06-0.69-0.09' +
            'c-0.22-0.03-0.42-0.06-0.61-0.06c-0.19-0.01-0.36-0.02-0.53-0.05c-0.16,0.01-0.3,0-0.44-0.01c-1.08-0.07-1.94-0.14-2.81-0.17' +
            'c-0.86-0.04-1.81-0.06-2.84,0.07C7.39,45.71,5.06,46.5,3.16,45.67z"/>' +
            '</g>' +
            '<linearGradient id="SVGID_4_" gradientUnits="userSpaceOnUse" x1="46.0866" y1="85.1469" x2="55.6521" y2="85.1469">' +
            '<stop  offset="0" style="stop-color:#c29f49"/>' +
            '<stop  offset="1" style="stop-color:#e5d390"/>' +
            '</linearGradient>' +
            '<path class="st3" d="M50.75,74.02c0,0-10.49,22.27,0,22.31C61.46,96.37,51.37,72.68,50.75,74.02z"/>' +
            '<linearGradient id="SVGID_5_" gradientUnits="userSpaceOnUse" x1="56.4482" y1="80.2598" x2="69.8109" y2="80.2598">' +
            '<stop  offset="0" style="stop-color:#c29f49"/>' +
            '<stop  offset="1" style="stop-color:#e5d390"/>' +
            '</linearGradient>' +
            '<path class="st4" d="M56.46,74.07c0,0,7.01,17.07,12.34,11.29C74.24,79.45,56.03,73.05,56.46,74.07z"/>' +
            '<linearGradient id="SVGID_6_" gradientUnits="userSpaceOnUse" x1="30.5933" y1="80.2598" x2="45.1371" y2="80.2598">' +
            '<stop  offset="0" style="stop-color:#c29f49"/>' +
            '<stop  offset="1" style="stop-color:#e5d390"/>' +
            '</linearGradient>' +
            '<path class="st5" d="M45.06,74.72c0,0-18.21,3.01-13.77,9.5C35.83,90.84,46.14,74.53,45.06,74.72z"/>' +
            '</g>' +
            '</svg>'
    }
}